module.exports = __webpack_public_path__ + "img/icon3.59d8e227.png";